export default __webpack_public_path__ + "static/media/remos-signal.ea22c8b4.png";